module.exports = __webpack_public_path__ + "static/media/black-diamond-logo-white.8c6c17a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/black-diamond-logo-white.png
// module id = 6858
// module chunks = 0